module.exports = __webpack_public_path__ + "static/media/home-bg-14.3ed47b87.jpg";